import React from 'react';
import { formatCurrency } from '@/modules/dashboard/utils/dashboard.helpers';
import '@/modules/dashboard/styles/DashboardCustomTooltip.css';

export default function DashboardCustomTooltip({ active, payload, valueFormatter = formatCurrency }) {
  if (!active || !payload || !payload.length) return null;

  const item = payload[0];
  const total = item?.payload?.total || 0;
  const percentage = total > 0 ? ((item.value / total) * 100).toFixed(1) : '0.0';

  return (
    <div className="dashboard-custom-tooltip">
      <p className="dashboard-custom-tooltip__title">{item.name}</p>
      <p className="dashboard-custom-tooltip__value">{valueFormatter(item.value)}</p>
      <p className="dashboard-custom-tooltip__percentage">{percentage}%</p>
    </div>
  );
}
